var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.SI=require("moment");module.exports=$CLJS.SI;